import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreConstants } from 'src/app/shared/models/store.model';
import * as IncomingTopicsV2Reducer from './reducer';
import { IncomingTopicsV2State, IncomingTopicsPageResult } from './reducer';

export const getIncomingTopicsV2State = createFeatureSelector<IncomingTopicsV2State>(StoreConstants.FEATURE_STORE_INCOMING_TOPICS_V2);

const pageResultState = createSelector(getIncomingTopicsV2State, IncomingTopicsV2Reducer.pageResult);

export const getPageResult = (viewId: string) =>
  createSelector(pageResultState, (pageResult: Record<string, IncomingTopicsPageResult>) => {
    if (!pageResult || !pageResult[viewId]) {
      return null;
    }
    return pageResult[viewId];
  });

const pageLoadingState = createSelector(getIncomingTopicsV2State, IncomingTopicsV2Reducer.pageLoading);

export const getPageLoading = (viewId: string) =>
  createSelector(pageLoadingState, (loadingState: Record<string, boolean>) => {
    if (!loadingState || !loadingState[viewId]) return false;
    return loadingState[viewId];
  });

export const getDetailsResult = createSelector(getIncomingTopicsV2State, IncomingTopicsV2Reducer.detailsResult);
export const getDetailsLoadedAt = createSelector(getIncomingTopicsV2State, IncomingTopicsV2Reducer.detailsLoadedAt);
export const getDetailsLoading = createSelector(getIncomingTopicsV2State, IncomingTopicsV2Reducer.detailsLoading);

export const getTileResult = createSelector(getIncomingTopicsV2State, IncomingTopicsV2Reducer.tilesResult);
export const getTilesLoading = createSelector(getIncomingTopicsV2State, IncomingTopicsV2Reducer.tilesLoading);
